import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';
// import {Http} from '@angular/http';
import {Response} from '@angular/http';

import {HttpService} from './services/HttpService';
import {NotificationService} from './services/NotificationService';

import {MDBBootstrapModule} from './angular-bootstrap-md';

import {APP_BASE_HREF} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

import {AppComponent} from './app.component';

import {SidebarModule} from './sidebar/sidebar.module';
import {FooterModule} from './shared/footer/footer.module';
import {NavbarModule} from './shared/navbar/navbar.module';
import {FixedpluginModule} from './shared/fixedplugin/fixedplugin.module';
import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {SuggestionsComponent} from './suggestions/suggestions.component';
import {ExtendedTableComponent} from './users/extendedtable/extendedtable.component';


import {AppRoutes} from './app.routing';
import {BrandsComponent} from './brands/brands.component';
import {EditUserComponent} from './edit-user/edit-user.component';
import {ViewAdminsComponent} from './view-admins/view-admins.component';
import {EditBrandComponent} from './edit-brand/edit-brand.component';
import {EditSuggestionComponent} from './edit-suggestion/edit-suggestion.component';
import {BrandProfileComponent} from './brand-profile/brand-profile.component';
import {ReportComponent} from './report/report.component';
import {SwearWordsComponent} from './swear-words/swear-words.component';

import {SocialLoginModule, AuthServiceConfig} from 'angular4-social-login';
import {GoogleLoginProvider, FacebookLoginProvider} from 'angular4-social-login';


import {FacebookModule} from 'ngx-facebook';
import {SortByPipe} from './pipes/sort-by.pipe';
import {DataTableDirective} from './directives/data-table.directive';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {ViewUserComponent} from './view-user/view-user.component';
import {HttpClientModule} from '@angular/common/http';
import {SubBrandsComponent} from './sub-brands/sub-brands.component';
import {AllSuggstionsComponent} from './all-suggstions/all-suggstions.component';
import {ClickoutsideDirective} from './directives/click-outside.directive';
import {SelectBrandComponent} from './select-brand/select-brand.component';
import {PaginationComponent} from './pagination/pagination.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatListModule} from '@angular/material/list';
import {MatInputModule} from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatMenuModule} from '@angular/material/menu';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LoadingModule} from 'ngx-loading';


let socialConfig = new AuthServiceConfig([
    {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('435410636872931')
    }
]);

export function provideConfig() {
    return socialConfig;
}

@NgModule({
    exports: [
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule
    ]
})
export class MaterialModule {
}

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot(AppRoutes),
        MDBBootstrapModule.forRoot(),
        MaterialModule,
        MatNativeDateModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        FixedpluginModule,
        SocialLoginModule,
        HttpClientModule,
        HttpModule,
        LoadingModule.forRoot({
            animationType: 'threeBounce',
            backdropBackgroundColour: 'rgba(0,0,0,0.5)',
            primaryColour: '#ffffff',
            secondaryColour: '#ffffff',
            tertiaryColour: '#ffffff',
            fullScreenBackdrop: true
        }),
        FacebookModule.forRoot(),
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        SuggestionsComponent,
        ExtendedTableComponent,
        BrandsComponent,
        EditUserComponent,
        ViewAdminsComponent,
        EditBrandComponent,
        EditSuggestionComponent,
        BrandProfileComponent,
        ReportComponent,
        SwearWordsComponent,
        SortByPipe,
        DataTableDirective,
        ChangePasswordComponent,
        ViewUserComponent,
        SubBrandsComponent,
        AllSuggstionsComponent,
        ClickoutsideDirective,
        SelectBrandComponent,
        PaginationComponent
    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA],
    entryComponents: [
        EditUserComponent,
        AppComponent,
        ViewAdminsComponent,
        EditBrandComponent,
        EditSuggestionComponent,
        BrandProfileComponent,
        ReportComponent,
        SwearWordsComponent,
        ChangePasswordComponent,
        ViewUserComponent,
        SubBrandsComponent,
        AllSuggstionsComponent,
        SelectBrandComponent
    ],
    providers: [
        {
            provide: AuthServiceConfig,
            useFactory: provideConfig
        }
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts